// Complete NAMTMessageType enum — mirrors C# NAMTMessageType (185 values, 0–184)
export enum NAMTMessageType {
  NOP = 0,
  DELETE_QUEUE = 1,
  RING = 2,
  RESET_DEVICE = 3,
  SMS_INTERFACE = 4,
  SET_GATEWAY_NUMBER = 5,
  SET_PASSWORD = 6,
  SET_DATA_ENABLED = 7,
  SET_DATA_DISABLED = 8,
  SET_SUBSCRIPTION_ACTIVE = 9,
  SET_SUBSCRIPTION_INACTIVE = 10,
  SET_REMOTE_SMS_ENABLED = 11,
  SET_REMOTE_SMS_DISABLED = 12,
  SET_VESSEL_TRACKING_ENABLED = 13,
  SET_VESSEL_TRACKING_DISABLED = 14,
  SET_SENSOR_DATA_REPORTING_ENABLED = 15,
  SET_SENSOR_DATA_REPORTING_DISABLED = 16,
  SET_GEOFENCE_USER_ENABLED = 17,
  SET_GEOFENCE_USER_DISABLED = 18,
  SET_SIREN_ENABLED = 19,
  SET_SIREN_DISABLED = 20,
  SET_ALERTS_ENABLED = 21,
  SET_ALERTS_DISABLED = 22,
  SET_GEOFENCE_ENABLED = 23,
  SET_GEOFENCE_DISABLED = 24,
  SET_GEOFENCE_RESET = 25,
  SET_GEOFENCE_DISTANCE = 26,
  GEOFENCE_STATUS = 27,
  GPS_STATUS = 28,
  MAP_REQUEST = 29,
  GET_STATUS = 30,
  SET_STATUS_ENABLED = 31,
  SET_STATUS_DISABLED = 32,
  WATER_STATUS = 33,
  DEPTH_STATUS = 34,
  NEVATA_WIRELESS_STATUS = 35,
  CELLULAR_STATUS = 36,
  DC_STATUS = 37,
  TOUCH_STATUS = 38,
  PASSWORD_STATUS = 39,
  SET_VESSEL_TRACKING_UPDATE_RATE_MINUTES = 40,
  SET_VESSEL_TRACKING_UPDATE_DISTANCE_FEET = 41,
  SET_SENSOR_DATA_REPORTING_UPDATE_RATE_MINUTES = 42,
  SET_GEOFENCE_LAT_LON = 43,
  SET_ALERT_CONTACT_LIST = 44,
  RESET_DEFAULTS = 45,
  INIT_REQUEST = 46,
  SENSOR_MAP_REQUEST = 47,
  VESSEL_TRACKING_DATA_REQUEST = 48,
  SET_VESSEL_NAME = 49,
  MT_MESSAGE_SET_GLOBAL_GEOFENCE_LIST = 50,
  MT_MESSAGE_RESET_SMS_COUNTERS = 51,
  SEND_LOCATION_REQUEST = 52,
  GET_SENSOR_DATA_REQUEST = 53,
  GET_DC_TREND_DATA = 54,
  SET_SECURITY_PASSCODE = 55,
  SET_SECURITY_DISARMED = 56,
  SET_SECURITY_ONBOARD = 57,
  SET_SECURITY_AWAY = 58,
  GET_SECURITY_DATA = 59,
  SET_SECURITY_ZONE_OPERATING_MODE = 60,
  DC_STATUS_X2 = 61,
  PASSWORD_STATUS_X2 = 62,
  WIRELESS_STATUS_X2 = 63,
  SET_SOS_SUBSCRIPTION_STATUS_ACTIVE_X2 = 64,
  SET_SOS_SUBSCRIPTION_STATUS_INACTIVE_X2 = 65,
  SET_SOS_RECEIVED_X2 = 66,
  SET_SOS_CANCELLED_X2 = 67,
  SMS_MESSAGE_X2 = 68,
  SET_TEXTING_ENABLED_X2 = 69,
  SET_TEXTING_DISABLED_X2 = 70,
  USE_PRIMARY_DNS_X2 = 71,
  USE_BACKUP_DNS_X2 = 72,
  SET_SOS_SUBSCRIPTION_DEVICE_REG_UPDATE_REQUIRED_X2 = 73,
  SET_SOS_SUBSCRIPTION_DEVICE_REG_UPDATE_REQUIRED_CLEARED_X2 = 74,
  SEND_LOCATION_REQUEST_VMS = 75,
  SET_VMS_PARAMS = 76,
  SET_VMS_ENABLED = 77,
  SET_VMS_DISABLED = 78,
  SET_STALE_LOCATION_THRESHOLD_SECONDS = 79,
  SET_STALE_NETWORK_THRESHOLD_SECONDS = 80,
  SET_PUMP_STATS_REPORTING_DISABLED = 81,
  SET_PUMP_STATS_MIN_REPORTING_ENABLED = 82,
  SET_PUMP_STATS_MAX_REPORTING_ENABLED = 83,
  SET_PUMP_STATS_MANUAL_OVERRIDE_REPORTING_ENABLED = 84,
  SET_PUMP_STATS_MANUAL_OVERRIDE_REPORTING_DISABLED = 85,
  SET_SERIAL = 86,
  SET_NO_BILGE_DISCHARGE = 87,
  SET_ENABLE_BILGE_DISCHARGE = 88,
  GET_DISCHARGE_STATUS = 89,
  SET_AUTO_BILGE_DISCHARGE_ENABLE = 90,
  SET_AUTO_BILGE_DISCHARGE_DISABLE = 91,
  GET_DAC_VALUES = 92,
  SET_NEVATA_ADVANCED_SETTINGS_ENABLED = 93,
  SET_NEVATA_ADVANCED_SETTINGS_DISABLED = 94,
  SET_TAMPER_DETECTION_ENABLED = 95,
  SET_TAMPER_DETECTION_DISABLED = 96,
  CLEAR_TAMPER_REPORTED = 97,
  GET_TAMPER_STATUS = 98,
  NEVATA_SET_NUM_PUMPS_CONTROLLED = 99,
  NEVATA_AUTO_CALIBRATE = 100,
  NEVATA_FORCE_CALIBRATE_NORMAL_OPERATION = 101,
  NEVATA_FORCE_CALIBRATE_MONITORING_MODE = 102,
  NEVATA_SET_INVALID_READINGS_THRESHOLD = 103,
  NEVATA_ENABLE_IGNORE_ACOUSTIC_SIGNAL_LOSS = 104,
  NEVATA_DISABLE_IGNORE_ACOUSTIC_SIGNAL_LOSS = 105,
  NEVATA_CLEAR_REPORTED_OBSTRUCTIONS = 106,
  NEVATA_SET_DISCHARGE_ZONE_SETTING = 107,
  NEVATA_SET_MANUAL_OVERRIDE = 108,
  NEVATA_SET_NEVATA_PARAMS = 109,
  NEVATA_ENABLE_DISABLE_ON_MOVEMENT = 110,
  NEVATA_DISABLE_DISABLE_ON_MOVEMENT = 111,
  NEVATA_SET_PUMP_ACTIVITY_SETTINGS = 112,
  NEVATA_GET_ADVANCED_SETTINGS = 113,
  UNPAIR_SENSOR = 114,
  ENABLE_SENSOR_PAIRING = 115,
  DISABLE_SENSOR_PAIRING = 116,
  SET_SENSOR_NAME = 117,
  SET_WIRELESS_SIREN_SYNC_MODE = 118,
  SET_SECURITY_ZONE_TYPE = 119,
  DC_BANK_SET_ENABLED = 120,
  DC_BANK_SET_DISABLED = 121,
  DC_BANK_SET_CHEMISTRY = 122,
  DC_BANK_SET_IS24V = 123,
  DC_BANK_SET_MIN_AND_MAX_VOLTAGE = 124,
  DC_BANK_SET_ALERT_THRESHOLDS = 125,
  DC_BANK_SET_DC_FILTER = 126,
  DC_BANK_SET_CALIBRATION_OFFSET = 127,
  DC_BANK_GET_SETTINGS = 128,
  SET_SECURITY_ZONE_INPUT_TYPE = 129,
  SET_SIREN_TRIGGER = 130,
  MT_MESSAGE_VMS_MESSAGE = 131,
  MT_MESSAGE_VMS_MESSAGE_ERROR = 132,
  MT_MESSAGE_SET_MESSAGE_BEEP_SETTING = 133,
  MT_MESSAGE_SET_FIRMWARE_UPDATE_AVAILABLE = 134,
  MT_MESSAGE_SET_FIRMWARE_UPDATE_REQUIRED = 135,
  MT_MESSAGE_CLEAR_FIRMWARE_UPDATE_FLAGS = 136,
  MT_MESSAGE_SET_SENSOR_OFFLINE_TIMER = 137,
  MT_MESSAGE_SET_TENDER_GEOFENCE_ENABLED = 138,
  MT_MESSAGE_SET_TENDER_GEOFENCE_DISABLED = 139,
  MT_MESSAGE_SET_TENDER_GEOFENCE_DISTANCE = 140,
  MT_MESSAGE_SET_TENDER_STALE_LOCATION_SETTING = 141,
  MT_MESSAGE_GET_TENDER_DATA = 142,
  MT_MESSAGE_SET_TENDER_LOCATION = 143,
  MT_MESSAGE_SET_COORD_AUTO_RESCAN_ENABLED = 144,
  MT_MESSAGE_SET_COORD_AUTO_RESCAN_DISABLED = 145,
  MT_MESSAGE_SET_GEO_AUTO_ARM_DISARM_MODE = 146,
  MT_MESSAGE_CLEAR_ALARMS = 147,
  MT_MESSAGE_SET_SWITCH_ON = 148,
  MT_MESSAGE_SET_SWITCH_OFF = 149,
  SET_TAMPER_ZONE_ENABLED = 150,
  SET_TAMPER_ZONE_DISABLED = 151,
  MT_MESSAGE_SET_VMS_ONLY_ENABLED = 152,
  MT_MESSAGE_SET_VMS_ONLY_DISABLED = 153,
  MT_MESSAGE_SET_SOS_SUBSCRIPTION_STATUS_ACTIVE_GEOS360 = 154,
  MT_MESSAGE_SET_SOS_SUBSCRIPTION_STATUS_ACTIVE_GEOS_GEOS360 = 155,
  MT_MESSAGE_SET_DC_DESCRIPTORS = 156,
  MT_MESSAGE_SET_ZONE_DESCRIPTORS = 157,
  MT_MESSAGE_GET_DC_DESCRIPTORS = 158,
  MT_MESSAGE_GET_ZONE_DESCRIPTORS = 159,
  MT_MESSAGE_AC_BANK_SET_ENABLED = 160,
  MT_MESSAGE_AC_BANK_SET_DISABLED = 161,
  MT_MESSAGE_SET_GPS_RESET_THRESHOLD_SECONDS = 162,
  MT_MESSAGE_SENSOR_OFFLINE_NETWORK_RESET_THRESHOLD_SECONDS = 163,
  MT_MESSAGE_SENSOR_NETWORK_RESET_THRESHOLD_SECONDS = 164,
  MT_MESSAGE_SET_GEOFENCE_ALERT_DELAY_SECONDS = 165,
  MT_MESSAGE_SET_GPS_DEGRAD_FT_THRESHOLD = 166,
  MT_MESSAGE_SET_NEVATA_FREEZE_ALERTS_ENABLED = 167,
  MT_MESSAGE_SET_NEVATA_FREEZE_ALERTS_DISABLED = 168,
  MT_MESSAGE_SET_NEVATA_NOISE_DETECT_ENABLED = 169,
  MT_MESSAGE_SET_NEVATA_NOISE_DETECT_DISABLED = 170,
  MT_MESSAGE_SET_NEVATA_NOISE_DETECT_NUM_TENTH_INCHES = 171,
  MT_MESSAGE_SET_NEVATA_NOISE_DETECT_NUM_SECONDS_SETTLE = 172,
  MT_MESSAGE_GET_DIRECT_CONNECT_SETTINGS = 173,
  MT_MESSAGE_SET_DIRECT_CONNECT_SETTINGS = 174,
  MT_MESSAGE_GET_MODEM_DETAILS = 175,
  MT_MESSAGE_CELLULAR_FW_UPDATE_REQUEST = 176,
  MT_MESSAGE_SET_APN = 177,
  MT_MESSAGE_SET_BLE_PARAMS = 178,
  MT_MESSAGE_DISABLE_BLE = 179,
  MT_MESSAGE_AT_COMMAND = 180,
  MT_MESSAGE_NEVATA_SET_COMPARATOR_VALUES = 181,
  MT_MESSAGE_GEOFENCE_SIREN_ENABLED = 182,
  MT_MESSAGE_MQTT_PROVISION = 183,
  MT_MESSAGE_MQTT_UNPROVISION = 184,
}

